<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Tabs/other'
 * Name: 'Kanban stage status'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3512-44343&m=dev'
 */
import type { BadgeKanbanStageStatusProps } from '../types/interfaces'

defineOptions({
  name: 'BadgeKanbanStageStatus',
})

defineProps<BadgeKanbanStageStatusProps>()
</script>

<template>
  <span :class="['badge-kanban-stage-status', color]">
    {{ text }}
  </span>
</template>

<style lang="scss" scoped src="../styles/_badge-kanban-stage-status.scss" />
